import _sfc_main from "./Input.vue2.js";
/* empty css           */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Input = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-96af89ab"]]);
export {
  Input as default
};
//# sourceMappingURL=Input.vue.js.map
